export default "__VITE_ASSET__DNnSDhAH__"